/** En dash — used for not-applicable / null in SECR tables (not ASCII hyphen). */
export const SECR_EM_DASH = '\u2013';

const intl = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * SECR report number formatting: always 2 decimal places, UK grouping.
 * Pass only finite numbers; null/NaN should be formatted as dash upstream.
 */
export function formatSecrReportNumber(value: number): string {
  return intl.format(value);
}
